import Zone from "@insite/client-framework/Components/Zone";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import AddToListModal from "@insite/content-library/Components/AddToListModal";
import Page from "@insite/mobius/Page";
import * as React from "react";
import { css } from "styled-components";

const pageStyles = {
    css: css`
        height: 100vh;
        > div {
            height: 100%;
        }
        overflow: unset !important;
    `,
};

const ProductConfigPage: React.FunctionComponent<PageProps> = ({ id }: PageProps) => (
    <Page data-test-selector="productConfigPage" padding={0} fullWidth={[true, true, true, true, true]} {...pageStyles}>
        <Zone contentId={id} zoneName="Content" />
        <AddToListModal />
    </Page>
);

const pageModule: PageModule = {
    component: ProductConfigPage,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            {
                ...HorizontalRule,
                sortOrder: 199,
            },
            HideHeader,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
        ],
        pageType: "Content",
    },
};

export default pageModule;

export const ProductConfigPageContext = "ProductConfigPage";
